import ServiceCRUD from '../../../services/ServiceCRUDSCALE';
import { apiGeneric } from '../../../http';

class OverTimesService extends ServiceCRUD {
  constructor() {
    super('/api/overtimes');
  }

  getAutomaticPauses(scaleId) {
    return apiGeneric.get(`scales/api/work-scales/${scaleId}`);
  }
}

export default new OverTimesService();
